import { FC } from "react";
import { ReactComponent as ActiveSVG } from "go-list/core/images/statuses/active.svg";
import { ReactComponent as DeletedSVG } from "go-list/core/images/statuses/disabled.svg";
import { ReactComponent as NewSVG } from "go-list/core/images/statuses/dismissed.svg";
import { ReactComponent as InactiveSVG } from "go-list/core/images/statuses/warning.svg";

interface Props {
	status?: string;
	className?: string;
}

const AppStatus: FC<Props> = ({ status, className }) => {
	switch (status) {
		case "NEW":
			return <InactiveSVG className={className} />;
		case "DELETED":
		case "ERROR":
			return <DeletedSVG className={className} />;
		case "ENABLED":
			return <ActiveSVG className={className} />;
		default:
			return <NewSVG className={className} />;
	}
};

export default AppStatus;
